import React from 'react';
import { useLocation } from 'react-router-dom';

import { StyledSkipLink, SkipTarget, FocusStart } from './styles';

export const MAIN_CONTENT_ID = 'main-content';

export const SkipLink: React.FunctionComponent = (): React.ReactElement => {
  const { pathname } = useLocation();
  const focusStartRef = React.useRef<HTMLSpanElement>(null);
  const previousPathname = React.useRef(pathname);

  React.useEffect(() => {
    if (previousPathname.current === pathname) return;
    previousPathname.current = pathname;
    focusStartRef.current?.focus();
  }, [pathname]);

  const onClick = (event: React.MouseEvent<HTMLAnchorElement>): void => {
    // Move focus, not just the scroll position, so the next Tab starts in the page content.
    event.preventDefault();
    document.getElementById(MAIN_CONTENT_ID)?.focus();
  };

  return (
    <>
      <FocusStart ref={focusStartRef} tabIndex={-1} />
      <StyledSkipLink href={`#${MAIN_CONTENT_ID}`} onClick={onClick}>
        Skip to main content
      </StyledSkipLink>
    </>
  );
};

export const SkipLinkTarget: React.FunctionComponent = (): React.ReactElement => (
  <SkipTarget id={MAIN_CONTENT_ID} tabIndex={-1} />
);

export default SkipLink;
